
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/staff/professional/[profile]",
      function () {
        return require("private-next-pages/staff/professional/[profile].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/staff/professional/[profile]"])
      });
    }
  